import { LABELS } from './flatfileLabels'
import getColumnWidth from '../utils/getFlatfileColumnWidth'
import { IRA_AMOUNT } from './iraAmount'

export const getUchParticipantFields = (userAudience) => [
  {
    key: 'recordkeeper',
    label: LABELS.RECORDKEEPER,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'recordKeeper' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.RECORDKEEPER),
    },
  },
  {
    key: 'tpa',
    label: LABELS.THIRD_PARTY_ADMINISTRATOR,
    type: 'string',
    constraints:
      userAudience === 'Recordkeeper'
        ? [{ type: 'external', validator: 'tpa' }]
        : [{ type: 'required' }, { type: 'external', validator: 'tpa' }],
    appearance: {
      size: getColumnWidth(LABELS.THIRD_PARTY_ADMINISTRATOR),
    },
  },
  {
    key: 'planSponsor',
    label: LABELS.PLAN_SPONSOR,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planSponsor' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.PLAN_SPONSOR),
    },
  },
  {
    key: 'planName',
    label: LABELS.COMPLETE_LEGAL_PLAN_NAME,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.COMPLETE_LEGAL_PLAN_NAME),
    },
  },
  {
    key: 'planEin',
    label: LABELS.EMPLOYER_IDENTIFICATION_NUMBER,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'planEin' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.EMPLOYER_IDENTIFICATION_NUMBER),
    },
  },
  {
    key: 'planNumber',
    label: LABELS.THREE_DIGIT_PLAN_NUMBER,
    type: 'string',
    constraints: [{ type: 'external', validator: 'planNumber' }],
    appearance: {
      size: getColumnWidth(LABELS.THREE_DIGIT_PLAN_NUMBER),
    },
  },
  {
    key: 'planIdNumber',
    label: LABELS.PROVIDER_PLAN_ID_NUMBER,
    type: 'string',
    constraints: [{ type: 'external', validator: 'planIdNumber' }],
    appearance: {
      size: getColumnWidth(LABELS.PROVIDER_PLAN_ID_NUMBER),
    },
  },
  {
    key: 'firstName',
    label: LABELS.FIRST_NAME,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'firstName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.FIRST_NAME),
    },
  },
  {
    key: 'middleName',
    label: LABELS.MIDDLE_NAME,
    type: 'string',
    constraints: [{ type: 'external', validator: 'middleName' }],
    appearance: {
      size: getColumnWidth(LABELS.MIDDLE_NAME),
    },
  },
  {
    key: 'lastName',
    label: LABELS.LAST_NAME,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'lastName' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.LAST_NAME),
    },
  },
  {
    key: 'addressLine1',
    label: LABELS.ADDRESS_LINE_1,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'addressLine1' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.ADDRESS_LINE_1),
    },
  },
  {
    key: 'addressLine2',
    label: LABELS.ADDRESS_LINE_2,
    type: 'string',
    constraints: [{ type: 'external', validator: 'addressLine2' }],
    appearance: {
      size: getColumnWidth(LABELS.ADDRESS_LINE_2),
    },
  },
  {
    key: 'city',
    label: LABELS.CITY,
    type: 'string',
    constraints: [{ type: 'external', validator: 'city' }],
    appearance: {
      size: getColumnWidth(LABELS.CITY),
    },
  },
  {
    key: 'state',
    label: LABELS.STATE,
    type: 'string',
    constraints: [{ type: 'external', validator: 'state' }],
    appearance: {
      size: getColumnWidth(LABELS.STATE),
    },
  },
  {
    key: 'zipCode',
    label: LABELS.ZIP_CODE,
    type: 'string',
    constraints: [{ type: 'external', validator: 'zipCode' }],
    appearance: {
      size: getColumnWidth(LABELS.ZIP_CODE),
    },
  },
  {
    key: 'countryCode',
    label: LABELS.COUNTRY_CODE,
    type: 'string',
    constraints: [
      { type: 'required' },
      { type: 'external', validator: 'countryCode' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.COUNTRY_CODE),
    },
  },
  {
    key: 'dob',
    label: LABELS.DATE_OF_BIRTH,
    type: 'string',
    constraints: [{ type: 'required' }],
    appearance: {
      size: getColumnWidth(LABELS.DATE_OF_BIRTH),
    },
  },
  {
    key: 'ssn',
    label: LABELS.SSN,
    type: 'string',
    constraints: [{ type: 'required' }, { type: 'external', validator: 'ssn' }],
    appearance: {
      size: getColumnWidth(LABELS.SSN),
    },
  },
  {
    key: 'emailAddress',
    label: LABELS.EMAIL_ADDRESS,
    type: 'string',
    constraints: [{ type: 'external', validator: 'emailAddress' }],
    appearance: {
      size: getColumnWidth(LABELS.EMAIL_ADDRESS),
    },
  },
  {
    key: IRA_AMOUNT.TRADITIONAL_PRE_TAX,
    label: LABELS.TRADITIONAL_IRA_AMOUNT,
    type: 'string',
    constraints: [
      { type: 'external', validator: 'traditionalIraPreTaxAmount' },
    ],
    appearance: {
      size: getColumnWidth(LABELS.TRADITIONAL_IRA_AMOUNT),
    },
  },
  {
    key: IRA_AMOUNT.ROTH,
    label: LABELS.ROTH_IRA_AMOUNT,
    type: 'string',
    constraints: [{ type: 'external', validator: 'rothIraAmount' }],
    appearance: {
      size: getColumnWidth(LABELS.ROTH_IRA_AMOUNT),
    },
  },
  {
    key: 'dateOfOriginalDistribution',
    label: LABELS.DATE_ORIGINAL_DISTRIBUTION,
    type: 'string',
    constraints: [],
    appearance: {
      size: getColumnWidth(LABELS.DATE_ORIGINAL_DISTRIBUTION),
    },
  },
  {
    key: 'wasTaxWithheld',
    label: LABELS.TAX_WITHHELD,
    type: 'string',
    constraints: [{ type: 'external', validator: 'wasTaxWithheld' }],
    appearance: {
      size: getColumnWidth(LABELS.TAX_WITHHELD),
    },
  },
]
